export default function pixelsToRem(pixels: number) {
	return `${0.0625 * pixels}rem`
}
